import { render, staticRenderFns } from "./ServiceTemplateList.vue?vue&type=template&id=b705fd5a"
import script from "./ServiceTemplateList.vue?vue&type=script&lang=js"
export * from "./ServiceTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports